import {Checkbox as CheckBoxMui, withStyles} from '@material-ui/core';

const Checkbox = withStyles(() => ({
  root: {
    '&.MuiCheckbox-colorSecondary.Mui-checked': {
      color: '#655DCB',
    },
  },
}))(CheckBoxMui);

export default Checkbox;
